<template>
  <el-dialog
    :visible.sync="show"
    custom-class="activityInfo"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="dialog-box">
      <div class="box" v-if="info">
        <img class="closebtn" src="@/assets/serve/designer/close.png" @click="closeDialog">
        <div class="swp">
          <el-carousel v-if="info">
            <el-carousel-item v-for="(item, index) in JSON.parse(info.photos)" :key="index" loop indicator-position="none">
              <img class="imgs" :src="item.pic_url" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="text">
          {{ info.comment }}
        </div>

        <div class="myd">
          <div class="line"></div>
          <div class="tip">满意度评分</div>
          <div class="grade-field">
            <el-rate
              v-model="info.grade"
              disabled>
            </el-rate>
          </div>
        </div>

        <div class="product">
          <div class="product-top">
            <div class="line"></div>
            <div class="tip">产品及花色</div>
          </div>
          <div class="text text-item" v-if="info">
            <div v-for="(item, index) in JSON.parse(info.products)" :key="index">
              {{ item.product + ' - ' + item.model }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ActivityInfo',
  
  components:{ 
  },

  props: {
    show: false,
    info: {}
  },

  data() {
    return {
    }
  },
  computed:{ },
  watch:{ },
  created() {
      
  },
  mounted() {
      
  },
  methods: {
    closeDialog() {
      this.$emit('close', false)
    }
  }
}
</script>
<style lang='less' scoped>
/deep/ .el-dialog.activityInfo {
  width: 600px;
  position: absolute;
  top: 34px;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 30px 30px;
  border-radius: 30px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    .el-carousel__container {
      height: 502px;
    }
    .swp{
      width: 100%;
      height: 502px;
      .imgs{
        vertical-align: top;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .my-swipe, .van-swipe{
      width: 100%;
      height: 100%;
    }
    .text{
      padding: 22px;
      font-size: 18px;
      color: #808080;
      line-height: 24px;
      text-align: left;
    }
    .myd{
      display: flex;
      align-items: center;
      margin-bottom: 27px;
      align-items: center;
    }
    .line{
      width: 2px;
      height: 18px;
      background-color: #009245;
      margin-left: 17px;
    }
    .tip{
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      margin-left: 5px;
    }
    .product{
      .product-top{
        display: flex;
        align-items: center;
      }
      .text-item{
        padding: 10px 22px;
        overflow: hidden;
        span{
          float: left;
          margin-right: 30px;
        }
      }
    }
    .grade-field {
      margin-left: 5px;
      display: flex;
      align-items: center;
      .el-rate__item {
        width: 22px;
        height: 22px;
        background: #e66237;
        margin-right: 10px;
        & i {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          &::before {
            font-size: 24px;
            color: #fff;
          }
        }
      }
    }
    .closebtn {
      width: 70px;
      height: 70px;
      position: absolute;
      top: 0px;
      right: -120px;
      cursor: pointer;
    }
  }
}
</style>